import CommercialTerms from './CommercialTerms'

export default CommercialTerms
